import { Drawer } from 'antd';
import styled from 'styled-components';
import colors from 'theme/colors';

export const DrawerStyled = styled(Drawer)`
  .ant-drawer-title {
    font-weight: bold;
    font-size: 1.3rem;
  }
  .ant-drawer-body {
    background: #f6f6f6;
  }
`;

export const AddNoteFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-bottom: 1rem;
  button {
    margin-top: 0.8rem;
    margin-left: 1rem;
  }
`;

export const DrawerNotes = styled.div`
  min-height: 400px;
  padding-bottom: 1px;
`;

export const HideBtn = styled.span`
  color: ${colors.primary};
`;
